module.exports = __webpack_public_path__ + "img/Goin_6.a2415d27.jpg";